export default {
  root: {
    overflow: 'inherit',
  },
};
